'use client'
import { useConfirmEmailCodeHandler } from '@/entities/session'
import { PropsWithChildren } from 'react'

export default function Layout({ children }: PropsWithChildren) {
  useConfirmEmailCodeHandler()
  return children
}
